<template>
  <div>
    <div class="big-title">
      <span>抽样品种及污染物选择</span>
    </div>
    <a-row>
      <a-row :gutter="4">
        <a-col :span="4">
          <span class="list-header">抽样品种选择</span>
        </a-col>
        <a-col :span="6">
          <span class="list-header">抽样比例</span>
        </a-col>
        <a-col :span="11">
          <span class="list-header">污染物选择</span>
        </a-col>
        <a-col :span="3">
        </a-col>
      </a-row>
      <a-row v-for="item in localValueFull" :gutter="4" :style="{margin:'4px'}">
        <a-col :span="4">
          <a-ext-check-box :label="item.name" v-model="item.checked" width="100%">
          </a-ext-check-box>
        </a-col>
        <a-col :span="6">
          <a-input-number
                  v-model="item.percent"
                  allowClear
                  :min="0"
                  :max="100"
                  :formatter="value => `${value}%`"
                  :parser="value => value.replace('%', '')"
                  placeholder="请输入抽检数量"></a-input-number>
        </a-col>
        <a-col :span="11">
          <div class="box" style="text-align: left">
            <template v-if="item.badThings">
              {{item.badThings}}
            </template>
            <a-button type="primary" v-else @click="item.badThings='sssss\ssss'">
              添加
            </a-button>
          </div>
        </a-col>
        <a-col :span="3">
          <a-button v-if="!item.badThings" type="link" @click="reChoice(item)">重新选择</a-button>
        </a-col>
      </a-row>
    </a-row>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
import AExtCheckBox from '../AExtPanelCheckBox/AExtCheckBox'
//TODO: 修改
import {getRegionTree as initFull} from '../../../api/api'

export default {
    name: "index",
    mixins:[mixin],
    components:{AExtCheckBox},
    props:{
        hangye:{
            type:String,
            default: ''
        },
        needCheck:{
            type:Boolean,
            default:false
        },
        badStdId:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            localValueFull:[],
            localValue: []
        }
    },
    created(){
        this.init()
    },
    watch:{
      localValueFull:{
          deep: true,
          immediate: true,
          handler: function (newValue) {
              let checkedItems=[];
              newValue.forEach(item=>{
                  if(item.checked)
                  {
                      checkedItems.push({
                          value:item.value,
                          checked:true,
                          percent:item.percent,
                          badThings:item.badThings
                      })
                  }
              });
              this.localValue=checkedItems;
          }
      }
    },
    methods:{
        init(){
            this.localValueFull=[];
            //查询行业下的所有农产品
            initFull("\'city\'").then(result => {
                if (result.data && result.data.succ) {
                    let fullProduce=result.data.data;
                    let  localFull=[];
                    fullProduce.forEach(item=>{
                        let obj={
                            name: item.name,
                            value: item.value,
                            checked: false,
                            percent:0,
                            badThings:''
                        };
                        localFull.push(obj);
                    });

                    if(!(this.localValue&&this.localValue.length>0)){
                      localFull.forEach(full=>{
                          this.localValue.forEach(inVal=>{
                              if (full.value===inVal.value)
                              {
                                  full.checked=true;
                                  full.percent=inVal.percent;
                                  full.badThings=inVal.badThings;
                              }
                          })
                      });
                    }
                    this.localValueFull=localFull;
                }
            }).catch(() => {
                this.localValueFull=[];
            });
        },
        reChoice(item){
            alert('重新选择')
        }
    }

}
</script>

<style scoped>
  .box{
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    padding-left: 5px;
    font-weight: 700;
    color: #7c7c7c;
    margin-right: 5px;
  }

  .total-box{
    font-weight: 700;
    color: #7c7c7c;
  }

  /deep/ .ant-select-selection--single{
    height: 40px;
  }

  /deep/ .ant-select{
    vertical-align: top;
  }

  /deep/ .ant-select-selection__rendered{
    line-height: 40px;
    color: #7c7c7c;
    font-weight: 700;
  }

  /deep/ .ant-input-number {
    height: 40px;
    vertical-align: top;
    width: 100%;
  }

  .list-header {
    padding-left: 20px;
    color: #888888;
    font-weight: 700;
  }

  .big-title {
    color: #444444;
    font-weight: 700;
  }
</style>